"use client";
import React from "react";
import "./page.css";
import BannerImage from "./BannerImage";
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import StartTrialBtn from "../StartTrialBtnProducts";
import Link from "next/link";
function handleClick(event) {
  event.preventDefault();
  console.info('You clicked a breadcrumb.');
}
const CaseStudyDetails3 = () => {
  return (
    <div>
      <section className="banner_bg1 case_study_supply_chain_analyticsbg">
        <div className="container banner_container1">
          <div className="banner_inner">
            <div className="banner_left">
              <h1 className="banner_heading1">
                Supply Chain Analytics Transformation for a Manufacturing Client
              </h1>
              <p className="banner_text1">
                Enhancing Supply Chain Insights and Efficiency
              </p>
              {/* <div className="banner_btn_container">
                <StartTrialBtn Text={"Get Started Today"} />
              </div> */}
            </div>
          </div>
        </div>
      </section>
      <section className="case-study-section">
      <div role="presentation" onClick={handleClick} className="container detail_breadcrumb">
            <Breadcrumbs aria-label="breadcrumb">

              <Link
                underline="hover"
                color="inherit"
                href="/case-studies"
              >
                Case studies
              </Link>
              <Typography sx={{ color: 'text.primary' }} className="active"> Supply Chain Analytics Transformation for a Manufacturing Client </Typography>
            </Breadcrumbs>
          </div>
        <div className="container">
        
          <div className="case-study-details">
            <h3 className="case-study-subheading">Client Overview</h3>
            <p>
              <strong>Client:</strong> A mid-sized manufacturing company producing consumer electronics.
            </p>
            <p>
              <strong>Industry:</strong> Manufacturing
            </p>
            <h3 className="case-study-subheading">The Challenge</h3>
            <p>
              The supply chain team relied on <strong>manual Excel-based reports </strong> for managing procurement, production
              planning, inventory, and logistics, leading to:
            </p>
            <ul>
              <li><strong>Fragmented Data:</strong> Data spread across multiple systems, such as ERP, inventory
              management, and shipping tools, creating inconsistencies.</li>
              <li><strong>Inefficiencies in Reporting:</strong> Preparing reports was time-intensive, with frequent errors and
              delays.</li>
              <li><strong>Limited Insights:</strong> Excel reports lacked advanced analytics capabilities for proactive decision-
              making.</li>
            </ul>
            <p>
            The client required a modern, automated analytics solution to integrate data sources, improve
            reporting, and provide actionable insights.
            </p>

            <h3 className="case-study-subheading">The Solution</h3>
            <p>The project involved setting up a <strong>centralized data pipeline </strong> using data engineering practices,
            developing <strong> interactive Power BI dashboards,</strong> and automating reporting processes.</p>

            <h3 className="sub_hdnum">1. Data Engineering: Centralizing Supply Chain Data</h3>

            <p className="main_listbull"><strong>Data Integration:</strong></p>
            <p className="sub_listbull">Connected multiple data sources, including:</p>
            <p className="sub_listbull_sq">ERP systems for procurement and production data.</p>
            <p className="sub_listbull_sq">Inventory management software.</p>
            <p className="sub_listbull_sq">Third-party logistics (3PL) systems for shipping and delivery tracking.</p>

            <p className="sub_listbull">Used <strong>Azure Data Factory </strong> to extract, transform, and load (ETL) data into a unified <strong> SQL database. </strong></p>

            <p className="main_listbull"><strong>Data Cleaning and Transformation:</strong></p>
            <p className="sub_listbull">Standardized key data points such as product codes, supplier IDs, and time stamps.</p>
            <p className="sub_listbull">Resolved inconsistencies, such as duplicate records and missing values.</p>
            <p className="main_listbull"><strong>Data Modeling:</strong></p>
            <p className="sub_listbull">Designed a star schema optimized for analytics, with:</p>
            <p className="sub_listbull_sq"><strong>Fact Tables:</strong> Procurement orders, production metrics, inventory
            transactions, and shipping records.</p>
            <p className="sub_listbull_sq"><strong>Dimension Tables:</strong> Products, suppliers, warehouses, locations, and dates.</p>
            
            



            <h3 className="sub_hdnum">2. Power BI Dashboards: Interactive Supply Chain Reporting</h3>
            <p className="main_listbull"><strong>Key Dashboards Developed:</strong></p>
            <p className="sub_listbull"><strong>Procurement Performance:</strong> Monitored supplier lead times, delivery accuracy, and cost trends.</p>
            <p className="sub_listbull"><strong>Inventory Management:</strong> Tracked stock levels, turnover rates, and reorder points by product and warehouse.</p>
            <p className="sub_listbull"><strong>Production Efficiency:</strong> Visualized machine utilization rates, production delays, and
            throughput trends.</p>
            <p className="sub_listbull"><strong>Logistics and Delivery:</strong> Analyzed on-time delivery rates, shipping costs, and transit
            times.</p>
            <p className="main_listbull"><strong>Advanced Visualizations:</strong></p>
            <p className="sub_listbull">Heatmaps for identifying underperforming suppliers or high-cost delivery routes.</p>
            <p className="sub_listbull">Line charts for inventory trends and forecasts.</p>
            <p className="sub_listbull">Drill-through capabilities for detailed analysis at the SKU or shipment level.</p>
            <p className="main_listbull"><strong>Real-Time Data Refresh: </strong> Enabled dashboards to pull data automatically from the centralized database, providing up-to-date insights.</p>


            <h3 className="sub_hdnum">3. Process Automation</h3>
            <p className="main_listbull"><strong>ETL Automation: </strong>  Scheduled daily and weekly data refreshes using Azure Data Factory.</p>
            <p className="main_listbull"><strong>Report Distribution: </strong>  Configured Power BI subscriptions to send tailored reports to
            stakeholders. </p>


            <h3 className="case-study-subheading">The Outcome</h3>

            <h3 className="sub_hdnum">1. Enhanced Reporting Efficiency</h3>
            <p className="main_listbull">Report preparation time reduced by <strong> 60%, </strong> saving the supply chain team 20+ hours per week.</p>

            <h3 className="sub_hdnum">2. Improved Decision-Making</h3>
            <p className="main_listbull">Real-time inventory dashboards reduced stockouts by <strong> 30% </strong> and excess inventory by <strong> 20%. </strong></p>
            <p className="main_listbull">Supplier performance insights helped renegotiate contracts with underperforming vendors,
            reducing procurement costs by <strong> 10%.</strong></p>
            <h3 className="sub_hdnum">3. Optimized Operations</h3>
            <p className="main_listbull">Production line bottlenecks were identified and resolved, improving throughput by <strong>15%.</strong></p>
            <p className="main_listbull">Logistics analysis reduced average delivery time by <strong> 20%, </strong> enhancing customer satisfaction.</p>

            <h3 className="sub_hdnum">4. Scalability</h3>
            <p className="main_listbull">The Power BI system supported the addition of new metrics (e.g., carbon footprint tracking) and accommodated future business growth.</p>
          </div>
          <h3 className="case-study-subheading">Key Takeaways</h3>
          <div className="key_takeways">
            <p className="main_listbull">A centralized data pipeline ensures consistency and reliability for supply chain analytics.</p>
            <p className="main_listbull">Power BI dashboards provide actionable insights through real-time visualizations and drill-down capabilities.</p>
            <p className="main_listbull">Automating reporting processes saves time and enables proactive decision-making in supply
            chain management.</p>
          </div>
        </div>
      </section>
      <section className="cta_outer retailmanufacturecta_bg">
        <div className="container cta_container">
          <div className="cta_inner">
          <div className="cta_innerout1">
            <div className="cta_left1">
              <h3 className="cta_hd">
                Ready to unlock the full potential of data for your retail business?
              </h3>
              <p className="cta_desc">
                Let’s discuss how our analytics solutions can help you succeed.
                Get Started today to see how we can drive meaningful results
                tailored to your needs.
              </p>
              <div className="banner_btn_container">
                <StartTrialBtn Text={"Get Started"} />
              </div>
              </div>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default CaseStudyDetails3;
